import {CatalogueFeatureTreeNode} from './buildFeatureTreesFromCatalogueKeys';

type CollapsedFeatureNode = {
  isFullySelected: boolean;
  selectedValues: string[];
};

export const collapseSelectedFeatureValues = (
  selected: string[],
  featureTrees: CatalogueFeatureTreeNode[]
): string[] => {
  const selectedValues = new Set(selected);
  const knownFeatureValues = new Set<string>();
  const collapsedSelectedValues = featureTrees.flatMap(
    (feature) => collapseFeatureNode(feature, selectedValues, knownFeatureValues).selectedValues
  );
  const unknownSelectedValues = selected.filter((value) => !knownFeatureValues.has(value));

  return [...collapsedSelectedValues, ...unknownSelectedValues];
};

const collapseFeatureNode = (
  feature: CatalogueFeatureTreeNode,
  selectedValues: Set<string>,
  knownFeatureValues: Set<string>
): CollapsedFeatureNode => {
  knownFeatureValues.add(feature.value);

  if (!feature.children.length) {
    const isSelected = selectedValues.has(feature.value);

    return {
      isFullySelected: isSelected,
      selectedValues: isSelected ? [feature.value] : [],
    };
  }

  const collapsedChildren = feature.children.map((child) =>
    collapseFeatureNode(child, selectedValues, knownFeatureValues)
  );
  const areAllChildrenSelected = collapsedChildren.every((child) => child.isFullySelected);

  if (selectedValues.has(feature.value) || areAllChildrenSelected) {
    return {
      isFullySelected: true,
      selectedValues: [feature.value],
    };
  }

  return {
    isFullySelected: false,
    selectedValues: collapsedChildren.flatMap((child) => child.selectedValues),
  };
};
